import styled from "styled-components";
export const TagsStyle = styled.div`
  margin-top: 1rem;
  border-radius: 10px;
  box-shadow: 0px 1px 10px #00000050;
  .header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: ${({ theme }) => theme.body};
    padding: 5px 10px;
    p {
    }
  }
  .body {
    background-color: ${({ theme }) => theme.box};
  }
`;
